import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import {
  createRootRouteWithContext,
  Outlet,
  useMatches,
} from "@tanstack/react-router"
import { ShowIfDebugControlsEnabled } from "../-components/hide-on-environment"
import { RouterContext } from "../router"
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
})

function Root() {
  // based on https://github.com/TanStack/router/discussions/1056
  const matches = useMatches()
  React.useEffect(() => {
    // Set document title based on lowest matching route with a title
    const breadcrumbPromises = [...matches]
      .reverse()
      .map((match, index) => {
        if (match.context && !("getTitle" in match.context)) {
          if (index === 0 && import.meta.env.DEV) {
            console.warn("no getTitle", match.pathname, match)
          }
          return undefined
        }
        const { context } = match
        return context?.getTitle && context.getTitle()
      })
      .filter(Boolean)
    Promise.all(breadcrumbPromises).then((titles) => {
      document.title = titles.join(" · ")
      return titles
    })
  }, [matches])

  return (
    <>
      <Outlet />
      <ShowIfDebugControlsEnabled>
        <ReactQueryDevtools buttonPosition="bottom-right" />
        <TanStackRouterDevtools position="bottom-right" />
      </ShowIfDebugControlsEnabled>
    </>
  )
}
